module.exports = __webpack_public_path__ + "assets/a25aee262affb2b49c17fbd29251419a.png";